import { notification } from 'antd';
import { persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';
import { apiLoginRenovarToken } from '@/features/login/api/apiLoginRenovarToken';
import { router } from '@/router/Router';
import type { ApiLoginAdmin } from './api/apiLoginAdmin';

type LoginAdminStore = {
    loginAdmin: ApiLoginAdmin | undefined;
    acessoNegadoMessage: string | undefined;
    codigoVerificado: boolean;
    renovandoToken: boolean;

    renovarToken: () => Promise<void>;
    clearLogin: () => void;
};

export const useLoginAdminStore = create<LoginAdminStore>()(
    persist(
        (set, get) => ({
            acessoNegadoMessage: undefined,

            clearLogin: () => {
                set({ loginAdmin: undefined });
            },
            codigoVerificado: false,
            loginAdmin: undefined,
            renovandoToken: false,

            renovarToken: async () => {
                const { loginAdmin, renovandoToken } = get();

                if (renovandoToken) {
                    return;
                }

                set({ renovandoToken: true });

                try {
                    const response = await apiLoginRenovarToken();

                    set({
                        loginAdmin: loginAdmin
                            ? {
                                  ...loginAdmin,
                                  token: response.token,
                                  token_exp: response.token_exp,
                              }
                            : undefined,
                        renovandoToken: false,
                    });

                    window.location.reload();
                } catch (e) {
                    notification.error({
                        description: e.message,
                        title: 'Falha ao renovar token',
                    });

                    set({
                        loginAdmin: undefined,
                        renovandoToken: false,
                    });

                    void router.navigate({ to: '/admin/auth/login' });
                }
            },
        }),
        {
            name: 'loginAdmin',
            partialize: (state) => ({
                loginAdmin: state.loginAdmin,
            }),
        },
    ),
);
